import './_loader.scss';
import './_loader.dark-mode.scss';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Loader = ({ success, text, styles }) => (
  <div
    style={styles}
    className={classNames('loaders-loader', {
      'loaders-loader__success': success,
    })}
  >
    <div className={classNames('loaders-loader__content')}>
      <div className="loaders-loader__content-icon">
        {success ? (
          <div className="loaders-loader__icon loaders-loader__icon-success">
            <span className="far fa-check-circle" />
          </div>
        ) : (
          <div className="loaders-loader__icon loaders-loader__icon-loading">
            <span className="fas fa-spinner" />
          </div>
        )}
      </div>
      {text
        ? (
          <div className="loaders-loader__content-description">
            {text}
          </div>
        ) : null}
    </div>
  </div>
);

Loader.propTypes = {
  success: PropTypes.bool,
  text: PropTypes.string,
  styles: PropTypes.object,
};

export default Loader;
